import React from "react";
import { Col, Container, Row, Badge } from "reactstrap";

const Footer = () => {
  return (
    <React.Fragment>
      <footer className="footer galaxy-border-none">
        <Container fluid>
          <Row>
            <Col sm={6} className="d-flex align-items-center">
              <span style={{ fontSize: "0.85rem", color: "#64748b", fontWeight: "500" }}>
                {new Date().getFullYear()} ©{" "}
                <span style={{ fontWeight: "800", marginRight: "10px" }}>
                  <span style={{ color: "#1e3a8a" }}>TILogistic.</span>{" "}
                  <span style={{ color: "#3b82f6" }}>CoreLink систем</span>
                </span>
              </span>
              <div
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  padding: "0.2rem 0.6rem",
                  background: "linear-gradient(145deg, rgba(59,130,246,0.1), rgba(239,68,68,0.05))",
                  border: "1px solid rgba(59,130,246,0.2)",
                  color: "#2563eb",
                  borderRadius: "20px",
                  fontSize: "0.68rem",
                  fontWeight: "700",
                  letterSpacing: "0.5px",
                  boxShadow: "0 2px 4px rgba(59,130,246,0.05)",
                }}
              >
                <i className="ri-flashlight-fill me-1" style={{ fontSize: "0.75rem", color: "#ef4444" }}></i>
                v0.4.86
              </div>
            </Col>
            <Col sm={6}>
              <div
                className="text-sm-end d-none d-sm-block mt-1 mt-sm-0"
                style={{ fontSize: "0.85rem", color: "#64748b", fontWeight: "500" }}
              >
                Design & Developed by{" "}
                <span style={{ color: "#334155", fontWeight: "700", letterSpacing: "0.3px" }}>
                  Intell<span style={{ color: "#2563eb" }}>X</span>
                </span>
              </div>
            </Col>
          </Row>
        </Container>
      </footer>
    </React.Fragment>
  );
};

export default Footer;
